import styled, { keyframes } from 'styled-components';
import { Link } from 'features/shared/layouts/shared/SideBarTemplate';
import { ReactComponent as Arrow } from './arrow.svg';
export const Manager = styled.div`
  margin-top: 16px;
  padding: 0 28px;
  font-size: 12px;
  line-height: 16px;
`;

export const ManagerTitle = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
  color: #00ab6d;
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;

export const ManagerText = styled.div`
  margin-top: 4px;
`;
export const ManagerContact = styled.a`
  margin-top: 4px;
  display: block;
`;

const flashAnimation = keyframes`  
  0% { color: #1CC67F; }
  20% { color: rgba(9, 21, 38, 0.6); }
	30% { color: #1CC67F; }
  50% { color: rgba(9, 21, 38, 0.6); }
`;

export const FlashLink = styled(Link)`
  animation: ${flashAnimation} 2s infinite step-end;
`;

export const InactiveLink = styled(Link)`
  color: rgba(9, 21, 38, 0.35);
`;

export const TooltipWrap = styled.div`
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(20px);
`;

export const TooltipContent = styled.div`
  background: rgba(9, 21, 38, 0.85);
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 8px;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  padding: 16px;
  max-width: 250px;
  width: 250px;
`;

export const TooltipCorner = styled(Arrow)`
  position: absolute;
  transform: translateX(-50%);
`;
